import { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import useScreen from "../../providers/screen";
import HttpService from "../../services/http_service/HttpService";
import Http from "../../services/http/Http";
import Header from "./header";
import CartButtonStatus from "./CartButtonStatus";
import Lists from "./Lists";
import Loading from "./Loading";
import { Row, Col, Container } from "./style";

const Menu = (props) => {
  const { screen } = useScreen();

  const propsData = useRef(props);

  const [isLoadingGetData, setIsLoadingGetData] = useState(true);
  const [categories, setCategories] = useState([]);

  const getCategories = useCallback(() => {
    HttpService()
      .get("categories/products", { params: { isMenu: true } })
      .then((response) => {
        setCategories(response.data?.entity);
      })
      .catch((error) => {
        Http(
          error?.response?.status,
          error?.response?.data?.message,
          propsData?.current
        );
      })
      .finally(() => {
        setIsLoadingGetData(false);
      });
  }, []);

  useEffect(() => {
    getCategories();
  }, [getCategories]);

  return (
    <>
      <Row className={`row no-gutters pb-2-5 ${screen?.isDesktop && "mt-3"}`}>
        <Col className="col-12 text-right">
          <Header categories={categories} />
          <Container>
            {isLoadingGetData ? <Loading /> : <Lists categories={categories} />}
          </Container>
        </Col>
      </Row>
      {!screen?.isDesktop && <CartButtonStatus />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    settings: state.settings?.settings,
  };
};

export default connect(mapStateToProps, false)(Menu);
